import React, { useCallback, useEffect, useState } from "react";
import { packageDetails, useAppStore } from "../../../store";
import DataProvider from "../../../services";
import { GiCheckMark } from "react-icons/gi";
import { Button } from "antd";
import { PlusOutlined, MinusOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Loader from "../../../components/cards/loader";

export default function SelectPlan(props: any) {
  const { setPackage, packages, setPlan } = useAppStore();
  const { screen, setScreen } = props;
  const [loading, setLoading] = useState<any>();
  const [expandedId, setExpandedId] = useState<number | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await DataProvider.getAllPackages();
      setPackage(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [setPackage]);

  useEffect(() => {
    if (screen === 1) {
      fetchData();
    }
  }, [screen, fetchData]);

  async function onBuy(planx: packageDetails) {
    setPlan(planx);
    setScreen(2);
  }

  return (
    <div className="w-full">
      <Button
        onClick={() => setScreen(0)}
        icon={<ArrowLeftOutlined />}
        type="text"
        className="mb-3"
      >
        Back
      </Button>
      <div className="mb-5 text-center">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
          Choose a <span className="text-[#1A94EC]">Plan</span> that works for
          you
        </h1>
      </div>
      {loading && packages === null ? (
        <div className="border border-solid border-gray-200 rounded-xl flex justify-center items-center h-64">
          <Loader num={1} />
        </div>
      ) : packages && packages.length > 0 ? (
        <div className="max-w-2xl mx-auto space-y-4">
          {packages.map((pkg) => {
            const expanded = expandedId === pkg.id;
            return (
              <div
                key={pkg.id}
                className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow"
              >
                <button
                  type="button"
                  onClick={() => setExpandedId(expanded ? null : pkg.id)}
                  className="w-full text-left p-4 sm:p-5 flex items-start justify-between gap-3"
                  aria-expanded={expanded}
                >
                  <div className="min-w-0">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                      {pkg.description}
                    </h3>
                    <p className="text-xl sm:text-2xl font-bold text-[#1A94EC] mt-1">
                      GH¢{pkg.price}
                      <span className="text-sm font-normal text-gray-600">
                        /month
                      </span>
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      {pkg.offers.map((o) => o.name).join(" + ")}
                    </p>
                  </div>
                  <span className="shrink-0 mt-1 h-8 w-8 rounded-full border border-gray-300 flex items-center justify-center text-gray-500">
                    {expanded ? <MinusOutlined /> : <PlusOutlined />}
                  </span>
                </button>
                {expanded && (
                  <div className="px-4 sm:px-5 pb-5 pt-1 space-y-4 border-t border-gray-100">
                    {pkg.offers.map((offer, idx) => (
                      <div key={idx} className="pt-4">
                        <h4 className="font-semibold text-gray-900 mb-2">
                          {offer.name}
                        </h4>
                        <ul className="space-y-1.5">
                          {offer.list.map((item, idxx) => (
                            <li
                              key={idxx}
                              className="flex items-start gap-2 text-sm text-gray-700"
                            >
                              <GiCheckMark
                                size={14}
                                className="text-[#1A94EC] mt-0.5 shrink-0"
                              />
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                    <Button
                      onClick={() => onBuy(pkg)}
                      size="large"
                      className="w-full text-white font-semibold"
                      style={{ backgroundColor: "#1A94EC" }}
                    >
                      Buy now
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-gray-500 py-10">
          No plans available right now. Please check back later.
        </div>
      )}
    </div>
  );
}
